import { all, call, put, takeEvery, takeLatest } from 'redux-saga/effects';
import SUCCESS_MESSAGES from '../../../common/constants/SuccessMessagesConstants';
import { request } from '../../../common/util/RestClient';
import envConfig from '../../../config';
import {
  archiveKpiTemplate,
  createKpiTemplate,
  duplicateKpiTemplate,
  fetchAllKpiTemplates,
  fetchKpiTemplateById,
  updateKpiTemplate,
} from '../../routines/successplanTemplates/kpiTemplates';

const SUCCESS_PLAN_TEMPLATE_MGT_URL = `${envConfig.APIG_URL}template`;

export function* fetchAllKpiTemplatesSaga() {
  try {
    const response = yield call(
      request,
      `${SUCCESS_PLAN_TEMPLATE_MGT_URL}/kpi`
    );
    yield put(fetchAllKpiTemplates.success(response));
  } catch (error) {
    yield put(fetchAllKpiTemplates.failure({ error }));
  } finally {
    yield put(fetchAllKpiTemplates.fulfill());
  }
}

export function* fetchKpiTemplateByIdSaga({ payload }) {
  try {
    const response = yield call(
      request,
      `${SUCCESS_PLAN_TEMPLATE_MGT_URL}/kpi/${payload.KpiTemplateId}`
    );
    yield put(fetchKpiTemplateById.success(response));
  } catch (error) {
    yield put(fetchKpiTemplateById.failure({ error, noAlert: true }));
  } finally {
    yield put(fetchKpiTemplateById.fulfill());
  }
}

export function* duplicateKpiTemplateSaga({ payload }) {
  try {
    yield put(fetchKpiTemplateById.trigger(payload));
    yield put(duplicateKpiTemplate.success(payload));
  } catch (error) {
    yield put(duplicateKpiTemplate.failure({ error }));
  } finally {
    yield put(duplicateKpiTemplate.fulfill());
  }
}

export function* createKpiTemplateSaga({ payload }) {
  try {
    const { kpiTemplate, callbackFn } = payload;
    const response = yield call(
      request,
      `${SUCCESS_PLAN_TEMPLATE_MGT_URL}/kpi`,
      {
        method: 'POST',
        payload: kpiTemplate,
      }
    );
    yield put(
      createKpiTemplate.success({
        response,
        successMessage: SUCCESS_MESSAGES.CREATE_KPI_TEMPLATE,
      })
    );
    if (callbackFn && response?.data?.kpiTemplateId) {
      callbackFn();
    }
    yield put(fetchAllKpiTemplates.trigger());
  } catch (error) {
    yield put(createKpiTemplate.failure({ error }));
  } finally {
    yield put(createKpiTemplate.fulfill());
  }
}

export function* updateKpiTemplateSaga({ payload }) {
  try {
    const { kpiTemplate, kpiTemplateId, callbackFn } = payload;
    const response = yield call(
      request,
      `${SUCCESS_PLAN_TEMPLATE_MGT_URL}/kpi/${kpiTemplateId}`,
      {
        method: 'PUT',
        payload: kpiTemplate,
      }
    );
    yield put(
      updateKpiTemplate.success({
        response,
        successMessage: SUCCESS_MESSAGES.UPDATE_KPI_TEMPLATE,
      })
    );
    if (callbackFn && response?.data?.kpiTemplateId) {
      callbackFn();
    }
    yield put(fetchAllKpiTemplates.trigger());
  } catch (error) {
    yield put(updateKpiTemplate.failure({ error }));
  } finally {
    yield put(updateKpiTemplate.fulfill());
  }
}

export function* archiveKpiTemplateSaga({ payload }) {
  try {
    const { KpiTemplateId } = payload;
    const response = yield call(
      request,
      `${SUCCESS_PLAN_TEMPLATE_MGT_URL}/kpi/archive/${KpiTemplateId}`,
      {
        method: 'PATCH',
        payload: {},
      }
    );
    yield put(
      archiveKpiTemplate.success({
        response,
        successMessage: SUCCESS_MESSAGES.ARCHIVE_KPI_TEMPLATE,
      })
    );
    yield put(fetchAllKpiTemplates.trigger());
  } catch (error) {
    yield put(archiveKpiTemplate.failure({ error }));
  } finally {
    yield put(archiveKpiTemplate.fulfill());
  }
}
export default function* root() {
  yield all([
    takeLatest(fetchAllKpiTemplates.TRIGGER, fetchAllKpiTemplatesSaga),
    takeLatest(fetchKpiTemplateById.TRIGGER, fetchKpiTemplateByIdSaga),
    takeLatest(duplicateKpiTemplate.TRIGGER, duplicateKpiTemplateSaga),
    takeEvery(createKpiTemplate.TRIGGER, createKpiTemplateSaga),
    takeEvery(archiveKpiTemplate.TRIGGER, archiveKpiTemplateSaga),
    takeEvery(updateKpiTemplate.TRIGGER, updateKpiTemplateSaga),
  ]);
}
